import { useRouter } from 'next/router'
import type { ReactElement } from 'react'
import { createContext, useContext } from 'react'

type Props = {
  children: ReactElement
}

const ModelContext = createContext<object | undefined>(undefined)

const ModelProvider = ({ children }: Props) => {
  const router = useRouter()
  const {
    ModelID,
    ModelId,
    RangeCode,
    RC,
    rc,
    modelId,
    modelID,
    rangecode,
    modelid,
    model,
    Model,
  } = router.query

  const MODEL =
    Model ||
    model ||
    ModelID ||
    ModelId ||
    RangeCode ||
    RC ||
    modelid ||
    rangecode ||
    rc ||
    modelId ||
    modelID ||
    ''

  return <ModelContext.Provider value={MODEL}>{children}</ModelContext.Provider>
}

const useModel = () => {
  return useContext(ModelContext)
}

export { ModelProvider, useModel }
